module.exports = __webpack_public_path__ + "img/report-results.6f0d7e36.png";